/*
 * types/services/dr2am.tasks.roles.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbResponseState} from './PbResponseState';
import {PbRole} from './PbRole';

/**
 * The ServiceCreateRoleResponse model module.
 * @module model/ServiceCreateRoleResponse
 * @version version not set
 */
export class ServiceCreateRoleResponse {
  /**
   * Constructs a new <code>ServiceCreateRoleResponse</code>.
   * @alias module:model/ServiceCreateRoleResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceCreateRoleResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceCreateRoleResponse} obj Optional instance to populate.
   * @return {module:model/ServiceCreateRoleResponse} The populated <code>ServiceCreateRoleResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceCreateRoleResponse();
      if (data.hasOwnProperty('role'))
        obj.role = PbRole.constructFromObject(data['role']);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {module:model/PbRole} role
 */
ServiceCreateRoleResponse.prototype.role = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceCreateRoleResponse.prototype.state = undefined;


